import React, { useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import S from './style';
import { DoubleArrow } from '@mui/icons-material';
import data from '../../services/data';
import dataen from '../../services/dataen';
import { LocaleContext } from '../../locale-context';
import TranslateStatic from '../../locales/TranslateStatic';

export function SubCategory() {
  let { id, name } = useParams();
  const value = useContext(LocaleContext);
  const [result, setResult] = useState(false);

  useEffect(() => {
    if (value === "en") {
      let filterdata = dataen.find(element => element.category.id == id);
      setResult(filterdata);
    } else if (value === "tr") {
      let filterdata = data.find(element => element.category.id == id);
      setResult(filterdata);
    }
  }, [id, value]);

  // Decode URI component just in case the name in URL is encoded
  const decodedName = name ? decodeURIComponent(name).replace(/-/g, ' ') : "Kategori";

  return (
    <S.PageWrapper>
      <S.HeroSection>
        <div className="hero-content">
          <h1>{decodedName}</h1>
          <S.Breadcrumb>
            <Link to="/"><TranslateStatic string="home" /></Link>
            <span className="separator">/</span>
            <span>{decodedName}</span>
          </S.Breadcrumb>
        </div>
      </S.HeroSection>

      <S.ContentWrapper>
        <div className="cards-grid">
          {result && result.category.subcategories.map((x, i) => {
            if (!x.hide) {
              return (
                <div className="item-wrapper" key={i}>
                  <h2>{x.name}</h2>
                  {x.link && (
                    <Link to={x.link}>
                      <TranslateStatic string="categoryDetailButton" /> <DoubleArrow />
                    </Link>
                  )}
                </div>
              );
            }
            return null;
          })}
        </div>
      </S.ContentWrapper>
    </S.PageWrapper>
  );
}
